import type { LocationQuery } from 'vue-router';
import { validateExternalSessionQuery } from '~/utils/session';

const STORAGE_KEY = 'isaac:external-session-query';

const stashExternalSessionQuery = (query: LocationQuery) => {
  if (!validateExternalSessionQuery(query)) return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(query));
};

const restoreExternalSessionQuery = (): LocationQuery => {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return {};

  try {
    return JSON.parse(raw) as LocationQuery;
  } catch {
    sessionStorage.removeItem(STORAGE_KEY);
    return {};
  }
};

const clearExternalSessionQuery = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export { stashExternalSessionQuery, restoreExternalSessionQuery, clearExternalSessionQuery };
